import $ from 'jquery';
import 'jquery-mask-plugin';

$(function () {
    let apply_form = $('#apply-form');

    if (!apply_form.length) {
        return;
    }

    let iso_code = apply_form.data('iso-code');
    let first_step = $(`[data-step="${apply_form.data('first-step-name')}"]`);
    let verification_code;
    let verification_code_resent = false;
    let submitting = false;

    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
        },
    });

    first_step.show();
    update_progress_bar(first_step);

    $('#phone_number').mask('000  000 0000');

    $('#phone_number').on('focus', function () {
        if ($(this).val().length == 0)
            $('#phone_number_mask').css('display', 'block');
    });

    $('#phone_number').on('blur', function () {
        if ($(this).val().length == 0)
            $('#phone_number_mask').css('display', 'none');
    });

    $('#phone_number').on('keyup', function () {
        $('#phone_number_value').text($(this).val());
    });

    $('.btn-check').on('change', function () {
        go_to_next_step($(this));
    });

    $('.btn-continue').on('click', function () {
        go_to_next_step($(this));
    });

    $('.btn-back').on('click', function () {
        go_to_prev_step($(this));
    });

    $('.btn-resend').on('click', function () {
        if (verification_code_resent) {
            return;
        }

        let element = $(this);

        $.post('/' + iso_code + '/apply/resend-verification-code', apply_form.serializeArray(), function (data) {
            verification_code_resent = true;

            element.addClass('text-muted');
            element.prop('disabled', true);
        });
    });

    $('.btn-submit').on('click', function () {
        let current_step = $(this).closest('[data-step]');

        if (!validate_step(current_step)) {
            return;
        }

        if (!submitting) {
            submitting = true;

            $(this).find('.loading-spinner').removeClass('d-none');
            apply_form.trigger('submit');
        }
    });

    function go_to_prev_step(element) {
        let current_step = element.closest('[data-step]');
        let prev_step = current_step.prev('[data-step]');

        current_step.fadeOut('fast', function () {
            prev_step.fadeIn('fast');
        });

        update_progress_bar(prev_step);
    }

    function go_to_next_step(element) {
        let current_step = element.closest('[data-step]');
        let next_step = current_step.next('[data-step]');

        if (!validate_step(current_step)) {
            return;
        }

        if (current_step.data('step') == 'employment_status') {
            let employment_status = $('[name="employment_status"]:checked').val();

            if (employment_status == 'Student') {
                next_step = $('[data-step="working_in_school"]');
            }
            else if (employment_status == 'Retired / Pension') {
                $('#employer').val('Retired');
                $('#job_title').val('Pension');

                next_step = $('[data-step="monthly_income"]');
            }
            else if (employment_status == 'Other') {
                next_step = $('[data-step="income_source"]');
            }
            else {
                next_step = $('[data-step="job"]');
            }
        }

        if (current_step.data('step') == 'working_in_school') {
            let working_in_school = $('[name="working_in_school"]:checked').val();

            if (working_in_school == 'Yes') {
                next_step = $('[data-step="job"]');

                $('#employment_status_0').prop('checked', true);
            }
            else {
                next_step = $('[data-step="monthly_income"]');
            }
        }

        if (current_step.data('step') == 'income_source') {
            next_step = $('[data-step="monthly_income"]');
        }

        if (current_step.data('step') == 'contact') {
            $.post('/' + iso_code + '/apply/send-verification-code', apply_form.serializeArray(), function (data) {
                verification_code = data.verification_code;
                verification_code_resent = false;

                $('.btn-resend').removeClass('text-muted');
                $('.btn-resend').prop('disabled', false);
            });
        }

        current_step.fadeOut('fast', function () {
            next_step.fadeIn('fast');
        });

        update_progress_bar(next_step);
    }

    function validate_step(current_step) {
        let step_name = current_step.data('step');
        let error = current_step.find('.error').first();
        let errors = [];

        $('.is-invalid').removeClass('is-invalid');

        error.text('');

        if (step_name == 'job') {
            if (!$('#employer').val().length) {
                $('#employer').addClass('is-invalid');
                errors.push(iso_code == 'fr' ? 'L\'employeur est requis' : 'Employer is required');
            }
            else if ($('#employer').val().length < 2) {
                $('#employer').addClass('is-invalid');
                errors.push(iso_code == 'fr' ? 'L\'employeur est trop court' : 'Employer is too short');
            }

            if (!$('#job_title').val().length) {
                $('#job_title').addClass('is-invalid');
                errors.push(iso_code == 'fr' ? 'Poste est requis' : 'Job title is required');
            }
            else if ($('#job_title').val().length < 2) {
                $('#job_title').addClass('is-invalid');
                errors.push(iso_code == 'fr' ? 'Poste est trop court' : 'Job title is too short');
            }
        }

        if (step_name == 'working_in_school') {
            if ($('[name="working_in_school"]:checked').val() == 'No') {
                errors.push(iso_code == 'fr' ? 'Vous devez être employé(e) pour continuer.' : 'You must be employed to continue');
            }
        }

        if (step_name == 'monthly_income') {
            if ($('[name="monthly_income"]:checked').val() == 'Under $2000 / month') {
                errors.push(iso_code == 'fr' ? 'Vous devez avoir un revenu d\'au moins 2000 $/mois pour continuer' : 'You must be making at least $2000 / month to continue');
            }

            if ($('[name="monthly_income"]:checked').val() == 'Under $2500 / month') {
                errors.push(iso_code == 'fr' ? 'Vous devez avoir un revenu d\'au moins 2500 $/mois pour continuer' : 'You must be making at least $2500 / month total income to continue.');
            }
        }

        if (step_name == 'income_length') {
            if ($('[name="income_length"]:checked').val() == 'Less than 3 months') {
                errors.push(iso_code == 'fr' ? 'Vous devez travailler pendant au moins 3 mois pour continuer' : 'You must be working for at least 3 months to continue');
            }
        }

        if (step_name == 'address') {
            if (!$('#address').val().length) {
                $('#address').addClass('is-invalid');
                errors.push(iso_code == 'fr' ? 'Adresse est requis' : 'Address is required');
            }

            if (!$('#city').val().length) {
                $('#city').addClass('is-invalid');
                errors.push(iso_code == 'fr' ? 'Ville / Localité est requis' : 'City / town is required');
            }

            if (!$('#province').val().length) {
                $('#province').addClass('is-invalid');
                errors.push(iso_code == 'fr' ? 'Province est requis' : 'Province is required');
            }
        }

        if (step_name == 'name') {
            if (!$('#first_name').val().length) {
                $('#first_name').addClass('is-invalid');
                errors.push(iso_code == 'fr' ? 'Prénom est requis' : 'First name is required');
            }
            else if ($('#first_name').val().length < 2) {
                $('#first_name').addClass('is-invalid');
                errors.push(iso_code == 'fr' ? 'Prénom est trop court' : 'First name is too short');
            }

            if (!$('#last_name').val().length) {
                $('#last_name').addClass('is-invalid');
                errors.push(iso_code == 'fr' ? 'Nom de famille est requis' : 'Last name is required');
            }
            else if ($('#last_name').val().length < 2) {
                $('#last_name').addClass('is-invalid');
                errors.push(iso_code == 'fr' ? 'Nom de famille est trop court' : 'Last name is too short');
            }
        }

        if (step_name == 'birth_date') {
            let current_year = new Date().getFullYear();
            let oldestYear = current_year - 65;
            let youngestYear = current_year - 21;

            if ($('#birth_year').val() > youngestYear || $('#birth_year').val() < oldestYear) {
                $('#birth_year').addClass('is-invalid');
                errors.push(iso_code == 'fr' ? 'Votre âge doit être compris entre 21 et 65 ans.' : 'Your age must be between 21 and 65.');
            }
        }

        if (step_name == 'contact') {
            if (!$('#email_address').val().length) {
                $('#email_address').addClass('is-invalid');
                errors.push(iso_code == 'fr' ? 'Adresse électronique est requis' : 'Email address is required');
            }
            else if (!/\S+@\S+\.\S+/.test($('#email_address').val())) {
                $('#email_address').addClass('is-invalid');
                errors.push(iso_code == 'fr' ? 'Adresse électronique est trop court' : 'Email address is invalid');
            }

            if (!$('#phone_number').val().length) {
                $('#phone_number').addClass('is-invalid');
                errors.push(iso_code == 'fr' ? 'Numéro de téléphone est requis' : 'Phone number is required');
            }
            else if ($('#phone_number').val().length != 13) {
                $('#phone_number').addClass('is-invalid');
                errors.push(iso_code == 'fr' ? 'Numéro de téléphone est invalide' : 'Phone number is invalid');
            }
        }

        if (step_name == 'verification_code') {
            if (!$('#verification_code').val().length) {
                $('#verification_code').addClass('is-invalid');
                errors.push(iso_code == 'fr' ? 'Code de vérification est requis' : 'Verficiation code is required');
            }
            else if ($('#verification_code').val() != verification_code) {
                $('#verification_code').addClass('is-invalid');
                errors.push(iso_code == 'fr' ? 'Code de vérification est invalide' : 'Verification code is invalid');
            }
        }

        if (errors.length) {
            error.html(errors.join('<br>'));

            return false;
        }

        return true;
    }

    function update_progress_bar(next_step) {
        let percent = next_step.index() / $('[data-step]').length * 100;

        $('#progress_bar').css('width', percent + '%');

        if (percent == 100) {
            $('#progress_time').text(iso_code == 'fr' ? 'Vous avez presque fini!' : 'You\'re almost done!');
        }
        else if (percent > 50) {
            $('#progress_time').text('1 min');
        }
    }
});
